import { useTranslation } from 'react-i18next'

import { Badge } from '@/components/ui/badge'

import * as S from './field-row.styled'

export const FieldBooleanBadge = ({ value }: { value: boolean }) => {
  const { t } = useTranslation(['organisation'])

  if (value) {
    return (
      <Badge color="green" size="small" variant="light">
        {t('organisation:places.save.on')}
      </Badge>
    )
  }

  return (
    <S.OffBadge color="neutral" size="small" variant="light">
      {t('organisation:places.save.off')}
    </S.OffBadge>
  )
}
